<template>
  <v-dialog v-model="visibility" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card class="dialog-list ">

      <v-toolbar dark color="primary">
        <slot name="left-side-action" />
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>

      <div class="container fill-overflow">
        <v-card class="fill-overflow">
          <v-list class="dialog-list-card fill-overflow py-0" two-line>
            <div class="dialog-list-list" data-test="student-list">
              <slot name="within-list" />
            </div>
          </v-list>
        </v-card>
      </div>

      <div class="container pt-0 dialog-list-action">
        <slot name="bottom-action" />
      </div>

    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'students-confirm',

  props: {
    visibility: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Maple Bear PWA'
    }
  }
}
</script>

<style lang="stylus" scoped>
  .dialog-list
    height 100%
    width 100%
    display flex
    flex-direction column
    &-card
      display flex
      flex-direction column
      flex 1
      height auto
    &-list
      overflow-y auto
    &-action
      flex 1 0 0
      align-content center
      height 56px

  .fill-overflow
    height 100%
    overflow hidden
</style>
